import { render, staticRenderFns } from "./ChamadosPendentes.vue?vue&type=template&id=182d3e58&"
import script from "./ChamadosPendentes.vue?vue&type=script&lang=js&"
export * from "./ChamadosPendentes.vue?vue&type=script&lang=js&"
import style0 from "./ChamadosPendentes.vue?vue&type=style&index=0&id=182d3e58&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports